import { render, staticRenderFns } from "./mark-item.vue?vue&type=template&id=49834b72"
import script from "./mark-item.vue?vue&type=script&lang=js"
export * from "./mark-item.vue?vue&type=script&lang=js"
import style0 from "./mark-item.vue?vue&type=style&index=0&id=49834b72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports